import { Shield, AlertTriangle, Zap } from 'lucide-react';

export { formatDate, formatDateShort, DAY_RANGES } from './varianceConfig';

export const preloadStates = {
  normal: {
    key: 'normal',
    label: 'Clear',
    icon: Shield,
    bg: 'bg-teal-50',
    text: 'text-teal-700',
    border: 'border-teal-200',
    dot: 'bg-teal-500',
    badgeBg: 'bg-teal-50',
    badgeBorder: 'border-teal-200',
    badgeText: 'text-teal-700',
    rowBg: '',
    accent: 'var(--accent)',
    chartColor: '#45B7AA',
  },
  watch: {
    key: 'watch',
    label: 'Watch',
    icon: AlertTriangle,
    bg: 'bg-amber-50',
    text: 'text-amber-700',
    border: 'border-amber-200',
    dot: 'bg-amber-500',
    badgeBg: 'bg-amber-50',
    badgeBorder: 'border-amber-200',
    badgeText: 'text-amber-700',
    rowBg: 'bg-amber-50/50',
    accent: 'var(--warning)',
    chartColor: '#d97706',
  },
  alert: {
    key: 'alert',
    label: 'Alert',
    icon: Zap,
    bg: 'bg-red-50',
    text: 'text-red-700',
    border: 'border-red-200',
    dot: 'bg-red-500',
    badgeBg: 'bg-red-50',
    badgeBorder: 'border-red-200',
    badgeText: 'text-red-700',
    rowBg: 'bg-red-50/50',
    accent: 'var(--danger)',
    chartColor: '#dc2626',
  },
};

export const getPreloadState = (preloadCount, alertThreshold) => {
  if (!preloadCount || preloadCount === 0) return preloadStates.normal;
  if (preloadCount < alertThreshold) return preloadStates.watch;
  return preloadStates.alert;
};

export const formatGap = (minutes) => {
  if (minutes == null) return '--';
  const h = Math.floor(minutes / 60);
  const m = minutes % 60;
  return h > 0 ? `${h}h ${m}m` : `${m}m`;
};

export const formatThreshold = (minutes) => {
  if (minutes == null) return '--';
  const h = Math.floor(minutes / 60);
  const m = minutes % 60;
  return m > 0 ? `${h}h ${m}m` : `${h}h`;
};
